import { configPromise } from "../../config/configMiddleware";
import { getWith, deleteWith, postWith, patchWith } from "../axios";

export async function GetPartner(partnerid: string | undefined): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/partner/` + partnerid;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetAllPartners(
  listPage: number,
  searchParam: string
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/partner/fetch-partners/${
      listPage ? listPage + 1 : 1
    }/${searchParam ? searchParam : ""}`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetAllPartnersFilterDeleted(
  listPage: number,
  searchParam: string
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${
      config.REACT_APP_API_URL
    }v1/partner/fetch-partners-filtered/${listPage ? listPage + 1 : 1}/${
      searchParam ? searchParam : ""
    }`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function DeletePartner(id: string | undefined): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/partner/` + id;
    return (await deleteWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function SoftDeletePartner(
  partnerid: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url =
      `${config.REACT_APP_API_URL}v1/partner/soft-delete/partner/` + partnerid;
    return (await patchWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function RestorePartner(
  partnerid: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url =
      `${config.REACT_APP_API_URL}v1/partner/restore/partner/` + partnerid;
    return (await patchWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function CreatePartner(partner: any): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/partner/`;
    return (await postWith<any, any>(url, partner)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function UpdatePartner(
  partner: any,
  partnerid: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/partner/` + partnerid;
    return (await patchWith<any, any>(url, partner)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function InvitePartner(
  partnerID: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/partner/invite-partner`;
    return (await postWith<any, any>(url, { partner_id: partnerID })) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function AcceptTermsAndConditions(partnerID: any): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/partner/accept-tandc/${partnerID}`;
    return (await postWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function DeletePartnerUser(id: string): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/user/` + id;
    return (await deleteWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetPartnerUsers(
  partnerid: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url =
      `${config.REACT_APP_API_URL}v1/partner/fetch-partner-users/` +
      partnerid +
      "/1";
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function CreatePartnerUser(teamMember: {
  partner_id: any;
  first_name: string;
  last_name: string;
  email_id: string;
  contact_number: string;
  contact_number_code: string;
  designation: string;
  user_type: string;
  role: string[];
}): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/user/org-user`;
    return (await postWith<any, any>(url, teamMember)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function UpdatePartnerUser(
  userID: string,
  teamMember: {
    partner_id: any;
    first_name: string;
    last_name: string;
    email_id: string;
    contact_number: string;
    contact_number_code: string;
    designation: string;
    user_type: string;
    role: string[];
  }
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/user/` + userID;
    return (await patchWith<any, any>(url, teamMember)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function CreatePartnerServices(
  partnerID: string | undefined,
  services: {
    region: number;
    regulatory_compliance: boolean;
    importation_clearance: boolean;
    warehousing_storage: boolean;
    ecom_setup_mgmt: boolean;
    retail_distribution: boolean;
    order_fulfilment: boolean;
    marketing: boolean;
  }[]
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/partner/partner-services`;
    return (await postWith<any, any>(url, {
      partner_id: partnerID,
      services: services,
    })) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function UpdatePartnerServices(
  partnerID: string | undefined,
  services: {
    region: number;
    regulatory_compliance: boolean;
    importation_clearance: boolean;
    warehousing_storage: boolean;
    ecom_setup_mgmt: boolean;
    retail_distribution: boolean;
    order_fulfilment: boolean;
    marketing: boolean;
  }[]
): Promise<any> {
  try {
    const config = await configPromise;
    const url =
      `${config.REACT_APP_API_URL}v1/partner/partner-services/` + partnerID;
    return (await patchWith<any, any>(url, {
      services: services,
    })) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function GetPartnerServicesList(
  partnerid: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url =
      `${config.REACT_APP_API_URL}v1/partner/partner-services/` + partnerid;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function createNewPartner(partner: any): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partnerV2/`;
    return (await postWith<any, any>(url, partner)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function assignConsultant(data: any, id: any) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/partner//asign-consultant/${id}`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    console.log(ex);
    throw ex.response.data;
  }
}

export async function UploadPartnerMandatoryFile(data: any) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partnerV2/upload-partner-mandatory-doc`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    console.log(ex);
    throw ex.response.data;
  }
}

export async function getPartnerAssetsRequests(
  brandId: string,
  req?: any
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partnerV2/documents-and-requests/${brandId}${req ? `?where=${JSON.stringify(req)}` : ""}`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function uploadPartnerFile(data: any) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partnerV2/upload-partner-doc`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    console.log(ex);
    throw ex.response.data;
  }
}

export async function updateUploadPartnerFile(id: string,data: any) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partnerV2/update-partner-doc/${id}`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    console.log(ex);
    throw ex.response.data;
  }
}

export async function getPartnerFile(partnerid: string | undefined) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partnerV2/list-partner-doc/${partnerid}`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    console.log(ex);
    throw ex.response.data;
  }
}

export async function deletePartnerFile(docId: string | undefined) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partnerV2/delete-partner-doc/${docId}`;
    return (await deleteWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    console.log(ex);
    throw ex.response.data;
  }
}

export async function getAllPartners(
  listPage: number,
  searchParam: string
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partnerV2/getAll/${
      listPage ? listPage + 1 : 1
    }?searchterm=${searchParam}`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getAllPartnersUnpaginated(): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partnerV2/get-all-partners`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getAllPartnersForConsultant(
  id: string | undefined,
  listPage: number,
  searchParam: string
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${
      config.REACT_APP_API_URL
    }v2/partnerV2/fetchPartnersofConsultant/${id}/${
      listPage ? listPage + 1 : 1
    }`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function softDeletePartner(
  partnerid: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partnerV2/soft-delete/${partnerid}`;
    return (await deleteWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getPartnerByID(
  partnerid: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partnerV2/${partnerid}`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function updatePartner(
  partner: any,
  partnerid: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partnerV2/${partnerid}`;
    return (await patchWith<any, any>(url, partner)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getConsultantsByPartnerID(
  partnerid: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partnerV2/fetchConsultantOfPartner/${partnerid}/1`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function requestForInformation(data: any) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/email/send/sendMoreInfoRequest`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    console.log(ex);
    throw ex.response.data;
  }
}

export async function hardDeletePartner(
  partnerid: string | undefined
): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partnerV2/hard-delete/${partnerid}`;
    return (await deleteWith<any, any>(url, {})) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getFilteredPartners(
  data: any,
  listPage: number,
  searchParam: string
) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partnerV2/filteredquery/${
      listPage ? listPage + 1 : 1
    }?searchterm=${searchParam}`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    console.log(ex);
    throw ex.response.data;
  }
}

export async function getFilteredPartnersForConsultant(
  consultantID: string,
  data: any,
  listPage: number,
  searchParam: string
) {
  try {
    const config = await configPromise;
    const url = `${
      config.REACT_APP_API_URL
    }v2/partnerV2/filteredquery/${consultantID}/${
      listPage ? listPage + 1 : 1
    }/${searchParam ? searchParam : ""}`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    console.log(ex);
    throw ex.response.data;
  }
}

export async function checkEmailDuplication(data: any) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partnerV2/check-poc-email`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    console.log(ex);
    throw ex.response.data;
  }
}

export async function checkPhoneDuplication(data: any) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partnerV2/check-poc-phone`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    console.log(ex);
    throw ex.response.data;
  }
}

export async function addNewPartner(partner: any): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partnerV2/`;
    return (await postWith<any, any>(url, partner)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}
